export const extractFilename = (path) => {
  const regex = /[^\\/:*?"<>|\r\n]+$/;
  const match = regex.exec(path);
  return match && match[0];
}